import { render, staticRenderFns } from "./album-details.component.vue?vue&type=template&id=740318a6&scoped=true&"
import script from "./album-details.component.vue?vue&type=script&lang=js&"
export * from "./album-details.component.vue?vue&type=script&lang=js&"
import style0 from "./album-details.component.vue?vue&type=style&index=0&id=740318a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740318a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VImg,VRow,VTooltip})
